import { ethers } from 'ethers'

/**
 * Convert a wagmi/viem Wallet Client into an ethers v6 Signer.
 * This keeps compatibility across injected wallets + WalletConnect.
 */
export async function walletClientToSigner(walletClient) {
  const { account, chain, transport } = walletClient

  const network = {
    chainId: chain.id,
    name: chain.name,
    ensAddress: chain.contracts?.ensRegistry?.address,
  }

  // ethers v6 BrowserProvider supports EIP-1193 providers; viem transport matches that shape.
  const provider = new ethers.BrowserProvider(transport, network)
  const signer = await provider.getSigner(account.address)
  return { signer, provider }
}

